export function sanitizeColor(color: string | undefined, fallback = '#ffffff'): string {
  if (!color) return fallback;

  const hexRegex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
  const rgbRegex = /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(,\s*[\d.]+\s*)?\)$/;
  const hslRegex = /^hsla?\(\s*\d+\s*,\s*\d+%\s*,\s*\d+%\s*(,\s*[\d.]+\s*)?\)$/;

  const namedColors = [
    'transparent', 'white', 'black', 'red', 'green', 'blue', 'yellow', 'cyan',
    'magenta', 'gray', 'grey', 'orange', 'purple', 'pink', 'brown', 'navy',
  ];

  const trimmedColor = color.trim().toLowerCase();

  if (hexRegex.test(trimmedColor)) {
    return trimmedColor;
  }

  if (rgbRegex.test(trimmedColor) || hslRegex.test(trimmedColor)) {
    return trimmedColor;
  }

  if (namedColors.includes(trimmedColor)) {
    return trimmedColor;
  }

  return fallback;
}

export function clampNumber(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
